var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInformation = function SvgInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 40,
    viewBox: "210 0 540 540"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.543 270h0c0-131.696 106.761-238.457 238.457-238.457h0A238.457 238.457 0 0 1 718.457 270h0c0 131.696-106.761 238.457-238.457 238.457h0c-131.696 0-238.457-106.761-238.457-238.457z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    d: "M241.543 270c0-131.696 106.761-238.457 238.457-238.457A238.457 238.457 0 0 1 718.457 270c0 131.696-106.761 238.457-238.457 238.457S241.543 401.696 241.543 270z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeWidth: 10,
    d: "M495.5 419.84h-36.141V208.512h36.14zm-39.063-267.39q0-8.782 5.36-14.829 5.374-6.062 15.921-6.062t16.016 6.062q5.469 6.047 5.469 14.844 0 8.781-5.47 14.64-5.468 5.86-16.015 5.86t-15.922-5.86q-5.36-5.859-5.36-14.656z"
  })));
};
export default SvgInformation;